__turbopack_context__.v({
  "heading": "ImageProductStrip-module-scss-module__dkuUJa__heading",
  "headingContainer": "ImageProductStrip-module-scss-module__dkuUJa__headingContainer",
  "image": "ImageProductStrip-module-scss-module__dkuUJa__image",
  "imageOverlay": "ImageProductStrip-module-scss-module__dkuUJa__imageOverlay",
  "imageProductStrip": "ImageProductStrip-module-scss-module__dkuUJa__imageProductStrip",
  "imageWrapper": "ImageProductStrip-module-scss-module__dkuUJa__imageWrapper",
  "mediaContainer": "ImageProductStrip-module-scss-module__dkuUJa__mediaContainer",
  "stripHeader": "ImageProductStrip-module-scss-module__dkuUJa__stripHeader",
  "stripHeading": "ImageProductStrip-module-scss-module__dkuUJa__stripHeading",
});
